/* eslint-disable import/prefer-default-export */

export const Facebook = () => (
  <svg width='7' height='13' viewBox='0 0 7 13' fill='#666666' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4.78788 2.59186C4.54545 2.59186 4.30303 2.83428 4.30303 3.25852V4.59186H6.66667V6.59186H4.24242V12.5312H2V6.65246H0V4.65246H2V3.50095C2 1.80398 3.21212 0.53125 4.78788 0.53125H6.66667V2.59186H4.78788Z' fill=''/>
  </svg>
);